// extracted by mini-css-extract-plugin
export default {"Zodiac":"_6xs2dAl","Label":"_HMWKsKq"};